import { render } from "./HeroiconsOutlineMenuAlt1.vue?vue&type=template&id=213803c2"
const script = {}

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMenuAlt1.vue"]])

export default __exports__